import type { ImgHTMLAttributes } from "react";
import { getResponsiveImageAsset } from "@/lib/responsiveImages";

type ResponsiveImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> & {
  src: string;
  sizes: string;
  priority?: boolean;
};

export default function ResponsiveImage({ src, sizes, priority = false, loading, decoding, ...props }: ResponsiveImageProps) {
  const asset = getResponsiveImageAsset(src);
  const image = (
    <img
      {...props}
      src={asset?.desktop ?? src}
      width={props.width ?? asset?.width}
      height={props.height ?? asset?.height}
      sizes={sizes}
      loading={priority ? "eager" : loading ?? "lazy"}
      fetchPriority={priority ? "high" : "auto"}
      decoding={decoding ?? "async"}
    />
  );

  if (!asset) return image;
  return (
    <picture>
      <source media="(max-width: 767px)" srcSet={asset.mobile} type={asset.type ?? "image/webp"} />
      {image}
    </picture>
  );
}
